import { InputType } from 'config'

export const RESPA6_COLLECTED = 'respa6DateCollected'

export const PRE_APPROVAL_HMDA_OPTIONS = {
  '1': 'Preapproval was Requested',
  '2': 'Preapproval was Not Requested',
}

export const PRE_APPROVAL_HMDA_NOT_REQUESTED = '2'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    preApprovalHmdaSelection: {
      inputType: 'select',
      title: 'Pre-Approval HMDA Selection',
      options: PRE_APPROVAL_HMDA_OPTIONS,
      hasDefaultOption: true,
      value: PRE_APPROVAL_HMDA_NOT_REQUESTED,
    },
    preApprovalIssuedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Pre-Approval Issued Date',
      value: '',
    },

    respa6DateCollected: { inputType: 'text', type: 'date', title: 'RESPA 6 Date', value: '' },
    respa6DateLocked: { inputType: 'checkbox', title: 'Lckd', value: false },
    loanEstimateDisclosedDate: {
      inputType: 'text',
      type: 'date',
      title: 'Loan Estimate Disclosed Date',
      value: '',
    },

    borrowerNameCollected: { inputType: 'text', type: 'date', title: 'Borrower Name Collected', value: '' },
    borrowerNameLocked: { inputType: 'checkbox', title: 'Lckd', value: false },
    borrowerNameEntered: { inputType: 'text', type: 'date', title: 'Borrower Name Entered', value: '' },
    borrowerNameApp1Date: { inputType: 'text', type: 'date', title: '', value: '' },

    borrowerSSNCollected: { inputType: 'text', type: 'date', title: 'Borrower SSN Collected', value: '' },
    borrowerSSNLocked: { inputType: 'checkbox', title: 'Lckd', value: false },
    borrowerSSNEntered: { inputType: 'text', type: 'date', title: 'Borrower SSN Entered', value: '' },
    borrowerSSNApp1Date: { inputType: 'text', type: 'date', title: '', value: '' },

    incomeCollected: { inputType: 'text', type: 'date', title: 'Income Collected', value: '' },
    incomeLocked: { inputType: 'checkbox', title: 'Lckd', value: false },
    incomeEntered: { inputType: 'text', type: 'date', title: 'Income Entered', value: '' },

    propertyAddressCollected: { inputType: 'text', type: 'date', title: 'Property Address Collected', value: '' },
    propertyAddressLocked: { inputType: 'checkbox', title: 'Lckd', value: false },
    propertyAddressEntered: { inputType: 'text', type: 'date', title: 'Property Address Entered', value: '' },

    propertyValueCollected: { inputType: 'text', type: 'date', title: 'Property Value Collected', value: '' },
    propertyValueLocked: { inputType: 'checkbox', title: 'Lckd', value: false },
    propertyValueEntered: { inputType: 'text', type: 'date', title: 'Property Value Entered', value: '' },

    loanAmountCollected: { inputType: 'text', type: 'date', title: 'Loan Amount Collected', value: '' },
    loanAmountLocked: { inputType: 'checkbox', title: 'Lckd', value: false },
    loanAmountEntered: { inputType: 'text', type: 'date', title: 'Loan Amount Entered', value: '' },
  }
}

export interface TridRow {
  collected: string
  locked: string
  entered: string | null
  app1Date?: string
}

export interface AdditionalPreApprovalIssued {
  date: string
  fileKey: string
}

export const ROWS: TridRow[] = [
  {
    collected: 'respa6DateCollected',
    locked: 'respa6DateLocked',
    entered: null,
  },
  {
    collected: 'borrowerNameCollected',
    locked: 'borrowerNameLocked',
    entered: 'borrowerNameEntered',
    app1Date: 'borrowerNameApp1Date',
  },
  {
    collected: 'borrowerSSNCollected',
    locked: 'borrowerSSNLocked',
    entered: 'borrowerSSNEntered',
    app1Date: 'borrowerSSNApp1Date',
  },
  {
    collected: 'incomeCollected',
    locked: 'incomeLocked',
    entered: 'incomeEntered',
  },
  {
    collected: 'propertyAddressCollected',
    locked: 'propertyAddressLocked',
    entered: 'propertyAddressEntered',
  },
  {
    collected: 'propertyValueCollected',
    locked: 'propertyValueLocked',
    entered: 'propertyValueEntered',
  },
  {
    collected: 'loanAmountCollected',
    locked: 'loanAmountLocked',
    entered: 'loanAmountEntered',
  },
]
